import { useEffect, useLayoutEffect, useRef, useState } from "react";
import CmsService from "../../../service/CmsService";
import DOMPurify from "dompurify";
import { useTranslation } from "react-i18next";
import { unzip } from "unzipit";

export function QuePreview({id,ancestorRect})
{
    const {t}=useTranslation();
    const [data,setData]=useState(t('No_content'));
    const childRef = useRef(null);
    const [calculatedHeight, setCalculatedHeight] = useState('300px'); 
    const containerRef = useRef(null);
    const [shadowRoot,setShadowRoot]=useState(null);

    useLayoutEffect(() => {
        if (!ancestorRect || !childRef.current) return;
        const childRect = childRef.current.getBoundingClientRect();
        const childRelativeTop = childRect.top - ancestorRect.top;
        const remainingHeight = ancestorRect.height - childRelativeTop - 25;
        setCalculatedHeight(remainingHeight>0?remainingHeight+'px':'300px');
    }, [ancestorRect]);

    useEffect(()=>{
        if(id == undefined)
            return;
        if(!containerRef.current)
            return;
        async function createUrl(entries,name){

        }
        async function loadDocument(buffer){
            const { entries } = await unzip(buffer);
            const names = Object.keys(entries);
            var html = await entries["jword.xhtml"].text();
            await Promise.all(Object.values(entries).map(async(entry) => {
                if(entry.name.startsWith('jword_files/style_1.css'))
                {
                    const cssContent = await entry.text();
                    const blob = new Blob([cssContent], { type: 'text/css' });                    
                    const link = URL.createObjectURL(blob);
                    html=html.replace(entry.name,link);
                }    
                else if(entry.name.startsWith('jword_files/image_'))
                {
                    const blob = await entry.blob();                    
                    const imgSrc = URL.createObjectURL(blob);
                    html=html.replace(entry.name,imgSrc);
                }    
            }));            
            var cleanHtml = html;//DOMPurify.sanitize(data);
            let shadowRoot = containerRef.current.shadowRoot;

            if (!shadowRoot) {
                shadowRoot = containerRef.current.attachShadow({ mode: 'open' });
            }            
            shadowRoot.innerHTML = cleanHtml;
            //setData(cleanHtml);
        }

        CmsService.getQuestionPreview(id).then((res)=>{
            loadDocument(res.data);
        });
    },[id]);
    /*return(
        <><div dangerouslySetInnerHTML={{__html:data}}></div></>
    )*/

    return(
        <div ref={containerRef}></div>
    )

    /*return(
        <div className="flex flex-grow-1">
            <embed width="100%" height={calculatedHeight} ref={childRef}
                src={CmsService.baseURL()+'/questions/'+id+'/preview'} style={{border:'0',margin:'0',padding:'0'}}></embed>
        </div>
    );*/
}